



































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IClient } from "@/models/clients";
import { QUERY_PARAMS } from "@/data/constants";
import { RegexMatch } from "@/data/enums/router";

@Component
export default class AdminClientsProductsAndServices extends Mixins(
  RequestPromises
) {
  // Props

  @Prop({ required: true })
  public client!: IClient;

  public guardFunctionalities = ["list_client_contracts_products"];
  public dataModule: DataModules = DataModules.CONTRACTS_PRODUCTS;

  public isLoading = false;
  public isReloading = false;
  public isProcessing = false;
  public requestError = false;

  public totalOrders = 0;

  public created() {
    if (!this.contentIsAvailable) {
      return;
    }

    this.isLoading = true;
    this.loadData();
  }

  public async loadData() {
    try {
      this.totalOrders = this.$_.get(
        await this.getClientContractProductsTotal(),
        "total",
        0
      );
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getClientContractProductsTotal() {
    return this.$store.dispatch(`data/${this.dataModule}/list`, {
      vm: this,
      scope: "count",
      returnData: false,
      storeData: false,
      params: {
        limit: "count",
        "filter[account_id]": this.clientAccountId,
        with_staged_imports: 1
      },
      ignoreStored: true
    });
  }

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }

  public get i18n() {
    return {
      cta:
        this.canCreateNewOrder && this.totalOrders > 1
          ? this.$t("_action.place_new_order")
          : "",
      title:
        this.$t(
          this.$_.reverse([...this.$route.matched]).find(i => i.meta?.title)
            ?.meta?.title
        ) || this.$t("_.products_and_services")
    };
  }

  public get clientId() {
    return this.$_.get(this.client, "id");
  }

  public get clientAccountId() {
    return this.$_.get(this.client, "accounts[0].id", null);
  }

  public get isStaged() {
    return !!this.$_.get(this.client, "staged_import", false);
  }

  public createNewOrder() {
    if (!this.canCreateNewOrder || this.isStaged) return;

    this.$router
      .push({
        name: "adminOrderShop",
        params: { basketId: RegexMatch.NEW },
        query: {
          [QUERY_PARAMS.CLIENT_ID]: this.clientId,
          [QUERY_PARAMS.ACCOUNT_ID]: this.clientAccountId
        }
      })
      .catch(err => err);
  }

  public get canCreateNewOrder() {
    return this.$userCan(`staff_create_order`) && this.clientAccountId;
  }

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
